module.exports = __webpack_public_path__ + "static/media/cell_preview3x.138d8fd8.png";